module.exports = __webpack_public_path__ + "static/media/Societe-Construction-Projets-Immobilier-Vaud.6dab22b3.jpg";